// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".storyblok-row{height:100%;display:flex}@media(max-width:960px){.storyblok-row{flex-direction:column}}.storyblok-row.footer-row{flex-wrap:wrap;justify-content:center}.storyblok-row.footer-row>div{margin-bottom:10px}@media(max-width:960px){.storyblok-row.footer-row>div{margin-bottom:15px}}", ""]);
// Exports
module.exports = exports;
